<template>
  <div
    ref="scrollArea"
    class="scroll-area"
    :class="{ 'top-shadow' : useTopShadow }"
  >
    <slot />
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'ScrollArea',
  data() {
    return {
      useTopShadow: false,
      debouncedTopShadowIfScrolled: debounce(this.setTopShadowIfScrolled, 15),
    };
  },
  mounted() {
    const scrollAreaElement = this.$refs.scrollArea;
    scrollAreaElement.addEventListener('scroll', this.debouncedTopShadowIfScrolled);
  },
  beforeDestroy() {
    const scrollAreaElement = this.$refs.scrollArea;
    scrollAreaElement.removeEventListener('scroll', this.debouncedTopShadowIfScrolled);
  },
  methods: {
    setTopShadowIfScrolled(event) {
      this.useTopShadow = event.target.scrollTop !== 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .scroll-area {
    &.top-shadow {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.025), transparent 20px);
      background-position-y: 1px;
    }

    display: grid;
    grid-template-rows: max-content 1fr;
    grid-gap: 40px;
    background-position-y: -10px;
    transition: background 0.2s;
    padding: 10px 0 20px 0;
    overflow: auto;
  }
</style>
